'use strict';

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _sha = require('sha.js');
var _sha2 = _interopRequireDefault(_sha);
var _qs = require('qs');
var _qs2 = _interopRequireDefault(_qs);
var _randombytes = require('randombytes');
var _randombytes2 = _interopRequireDefault(_randombytes);
var _lodash = require('lodash.merge');
var _lodash2 = _interopRequireDefault(_lodash);
var _events3 = require('events');
var _events4 = _interopRequireDefault(_events3);
require('regenerator-runtime');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// if promise hasn't been polyfilled polyfill it just for this file
var _Promise = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;
var SESSION_API_URL = 'https://sessions.cimpress.io/v1/sessions';
var PROFILE_API_URL = 'https://profile.cimpress.io/v1/profile';
var ACCOUNT_ID_CLAIM = 'https://claims.cimpress.io/account';
var TEST_USER_CLAIM = 'https://claims.cimpress.io/is_test_user';
var PROFILE_EXPIRY_TIME = 3600 * 1000;
var DEFAULT_OPTIONS = {
  redirectRoute: '',
  domain: 'cimpress.auth0.com',
  audience: 'https://api.cimpress.io/',
  scope: 'offline_access',
  // number of seconds offset - value of 30 means token will be considered expired 30 seconds before it actually expires with the provider
  sessionExpirationOffset: 30,
  // Check to see if the token is expired when the window comes into focus. This is because the expiration timer is sometimes unreliable.
  checkExpirationOnFocus: true
};

// https://auth0.com/docs/flows/authorization-code-flow-with-proof-key-for-code-exchange-pkce

var AuthorizationCodeGrantPKCE = function AuthorizationCodeGrantPKCE(options) {
  _classCallCheck(this, AuthorizationCodeGrantPKCE);
  _initialiseProps.call(this);
  (0, _lodash2.default)(this, DEFAULT_OPTIONS, options);
  this.redirectUri = window.location.origin + this.redirectRoute;
  this.events = new _events4.default();

  // listen for changes to localStorage that don't originate from this current window/tab
  window.addEventListener('storage', this.listenToStorage);

  // The sessionExpired event can be unreliable (for example when your computer goes to sleep)
  // So we are double checking that you are logged in when the browser tab gains focus.
  window.addEventListener('visibilityChange', this.handleFocusChange);
}

// Utility which enables a developer to subscribe to the events 'listenToStorage' & 'handleFocusChange'

// Utility which enables a developer to unsubscribe to the events 'listenToStorage' & 'handleFocusChange'

// It is possible to create an infinite loop between 2 tabs/windows if localStorage is modified
// within this listener - so don't do it :) 

// Check  session status by calling API

// Check for the session's expiration time whenever the the web browser's tab regains focus

// Generate a Code Verifier of 32 random bytes

// Encrypt the 32 random bytes with sha.js

// Encode the string so that its properly consumed by the auth0 server

// Generate the code verifier and code challenge and redirect the user to a centralized auth0 page

// If the redirect was from auth0 then a fresh session is created, else the existing session is checked for its validity and the necessary steps are performed

// This method is combination of handleAuthentication() method & login() method. Its the starting point of the authentication process

// Checks whether the call is sent back by auth0 server with the code and status as the url parameters.

// Extracts code and state params from the url and returns a dictionary.

// If it was a redirect from the auth0 server, then a fresh session is created and the profile information of the user is extracted.

// Returns a session for a user in exchange of a Authorization Code and Code Verifier

// Returns the status of the session in exchange of a session ID

// Returns the profile information of a user in exchange of a session ID

// Clears the timer instance 'expiresSessionTimeout' associated with the class 

// Closes the session in exchange of a session ID and clears the local storage

// Clears the local storage
;
var _initialiseProps = function _initialiseProps() {
  var _this = this;
  this.on = function (eventType) {
    var _events;
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    (_events = _this.events).on.apply(_events, [eventType].concat(args));
  };
  this.removeListener = function (eventType) {
    var _events2;
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    (_events2 = _this.events).removeListener.apply(_events2, [eventType].concat(args));
  };
  this.listenToStorage = function (e) {
    switch (e.key) {
      case 'sessionExpiresAt':
        // check to see if it's being removed or not
        if (e.newValue) {
          try {
            var expiresAt = JSON.parse(e.newValue);
            _this.setSessionExpirationTimer(expiresAt);
          } catch (e) {
            _this.clearLocalParams();
            console.error(e);
            throw new SyntaxError('An unexpected error occurred due to invalid sessionExpiresAt value: ' + e.message, e.stack);
          }
        }
        break;
      default:
    }
  };
  this.isLoggedIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var sessionId, sessionData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionId = localStorage.getItem('sessionId');
            if (!sessionId) {
              _context.next = 8;
              break;
            }
            _context.next = 4;
            return _this.checkSession(sessionId);
          case 4:
            sessionData = _context.sent;
            return _context.abrupt('return', ['ACCESS_TOKEN_PENDING', 'ACTIVE'].includes(sessionData.status));
          case 8:
            return _context.abrupt('return', _Promise.resolve(false));
          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
  this.handleFocusChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var expiration;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (document.visibilityState === 'visible' && _this.checkExpirationOnFocus) {
              // Always check for Session Expiration
              expiration = localStorage.getItem('sessionExpiresAt');
              if (expiration && expiration <= new Date().getTime() - _this.sessionExpirationOffset * 1000) {
                _this.events.emit('sessionExpired', expiration);
              }
            }
          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));
  this.generateCodeVerifier = function () {
    return _this.urlEncode((0, _randombytes2.default)(32).toString("base64"));
  };
  this.createCodeChallenge = function (codeVerifier) {
    return _this.urlEncode((0, _sha2.default)("sha256").update(codeVerifier).digest("base64"));
  };
  this.urlEncode = function (str) {
    return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  };
  this.login = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$nextUri = _ref3.nextUri,
      nextUri = _ref3$nextUri === undefined ? window.location.href : _ref3$nextUri,
      authorizeParams = _ref3.authorizeParams;
    var state = btoa(nextUri);
    var verifier = _this.generateCodeVerifier();
    var challenge = _this.createCodeChallenge(verifier);
    localStorage.setItem('codeVerifier', verifier);
    var queryStringParams = _extends({
      state: state,
      response_type: 'code',
      client_id: _this.clientID,
      audience: _this.audience,
      code_challenge: challenge,
      code_challenge_method: 'S256',
      scope: _this.scope,
      redirect_uri: _this.redirectUri
    }, authorizeParams);
    window.location = 'https://' + _this.domain + '/authorize?' + _qs2.default.stringify(queryStringParams);
    return _Promise.resolve();
  };
  this.handleAuthentication = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$performRedirect = _ref5.performRedirect,
        performRedirect = _ref5$performRedirect === undefined ? true : _ref5$performRedirect;
      var sessionId, sessionData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sessionId = localStorage.getItem('sessionId');
              if (!_this.wasAuth0Redirect()) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt('return', _this.handleRedirect({
                performRedirect: performRedirect
              }));
            case 5:
              if (!sessionId) {
                _context3.next = 13;
                break;
              }
              _context3.next = 8;
              return _this.checkSession(sessionId);
            case 8:
              sessionData = _context3.sent;
              if (!['ACCESS_TOKEN_PENDING', 'ACTIVE'].includes(sessionData.status)) {
                _context3.next = 13;
                break;
              }

              // set the latest expiry for session
              localStorage.setItem('sessionExpiresAt', new Date(sessionData.expiresAt).getTime());
              _this.setSessionExpirationTimer();
              return _context3.abrupt('return', _Promise.resolve(true));
            case 13:
              _this.clearLocalParams();
              return _context3.abrupt('return', _Promise.resolve(false));
            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function () {
      return _ref4.apply(this, arguments);
    };
  }();
  this.ensureAuthentication = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forceLogin = options.forceLogin;
    if (forceLogin) {
      return _this.login(options);
    }
    return _this.handleAuthentication().then(function (authenticated) {
      if (authenticated) {
        return _Promise.resolve(true);
      }
      return _this.login(options);
    });
  };
  this.wasAuth0Redirect = function () {
    var parsedUrl = _this.getFragments();
    return parsedUrl['code'] && parsedUrl['state'];
  };
  this.getFragments = function () {
    if (!window.location.search) {
      return {};
    }
    return window.location.search.substring(1).split('&').reduce(function (prev, cur) {
      var kv = cur.split('=');
      prev[kv[0]] = kv[1];
      return prev;
    }, {});
  };
  this.handleRedirect = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref7) {
      var performRedirect = _ref7.performRedirect;
      var parsedUrl, authorizationCode, state, nextUri, sessionData;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              parsedUrl = _this.getFragments();
              authorizationCode = parsedUrl['code'];
              state = parsedUrl['state'];
              nextUri = atob(decodeURIComponent(state));
              _context4.next = 7;
              return _this.createSession(authorizationCode);
            case 7:
              sessionData = _context4.sent;
              if (!sessionData.sessionId) {
                _context4.next = 18;
                break;
              }
              localStorage.removeItem('codeVerifier');
              // Store session related information
              localStorage.setItem('sessionId', sessionData.sessionId);
              localStorage.setItem('sessionExpiresAt', new Date(sessionData.expiresAt).getTime());

              // Call to get Profile information of user
              _context4.next = 14;
              return _this.getProfile(sessionData.sessionId);
            case 14:
              if (performRedirect) {
                window.location = nextUri || '/';
              }
              return _context4.abrupt('return', true);
            case 18:
              return _context4.abrupt('return', false);
            case 19:
              _context4.next = 25;
              break;
            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4['catch'](0);
              console.error(_context4.t0);
              return _context4.abrupt('return', false);
            case 25:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 21]]);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
  this.createSession = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(authorizationCode) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', _this.fetchUtil(SESSION_API_URL, {
                method: 'POST',
                body: JSON.stringify({
                  'origin': window.location.origin,
                  'clientId': _this.clientID,
                  'authorizationCode': authorizationCode,
                  'codeVerifier': localStorage.getItem('codeVerifier'),
                  'redirectUri': _this.redirectUri
                }),
                headers: new Headers({
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                })
              }));
            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
  this.checkSession = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(sessionId) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!sessionId) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt('return', _this.fetchUtil(SESSION_API_URL + '/' + sessionId + '/status?cacheBurst=' + Date.now()));
            case 4:
              return _context6.abrupt('return', _Promise.resolve({}));
            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));
    return function (_x6) {
      return _ref9.apply(this, arguments);
    };
  }();
  this.getProfile = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(sessionId) {
      var profileExpiresAt, _profileData, profileResponse, profileData;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              profileExpiresAt = localStorage.getItem('profileExpiresAt');
              if (!(!profileExpiresAt || profileExpiresAt <= new Date().getTime())) {
                _context7.next = 10;
                break;
              }
              _context7.next = 4;
              return _this.fetchUtil(PROFILE_API_URL + '/me', {
                method: 'GET',
                headers: new Headers({
                  'x-session-id': sessionId
                })
              });
            case 4:
              profileResponse = _context7.sent;
              profileData = (_profileData = {
                canonicalId: profileResponse.canonicalId,
                email: profileResponse.email,
                given_name: profileResponse.firstName,
                family_name: profileResponse.lastName || ""
              }, _defineProperty(_profileData, ACCOUNT_ID_CLAIM, profileResponse.accountId), _defineProperty(_profileData, 'name', profileResponse.firstName + (profileResponse.lastName === undefined ? "" : " " + profileResponse.lastName)), _defineProperty(_profileData, 'picture', profileResponse.pictureURL), _defineProperty(_profileData, TEST_USER_CLAIM, profileResponse.isTestUser), _profileData);
              if (profileData.canonicalId) {
                localStorage.setItem('profile', JSON.stringify(profileData));
                localStorage.setItem('profileExpiresAt', new Date().getTime() + PROFILE_EXPIRY_TIME);
              }
              return _context7.abrupt('return', profileData);
            case 10:
              return _context7.abrupt('return', JSON.parse(localStorage.getItem('profile')));
            case 11:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));
    return function (_x7) {
      return _ref10.apply(this, arguments);
    };
  }();
  this.clearSessionTimeout = function () {
    return _this.expiresSessionTimeout = window.clearTimeout(_this.expiresSessionTimeout);
  };
  this.setSessionExpirationTimer = function () {
    var sessionExpiresAt = localStorage.getItem('sessionExpiresAt');
    try {
      _this.clearSessionTimeout();
      var timeToWait = sessionExpiresAt - new Date().getTime() - 1000 * _this.sessionExpirationOffset;
      _this.expiresSessionTimeout = window.setTimeout(function () {
        return _this.events.emit('sessionExpired');
      }, Math.max(Math.min(Math.pow(2, 31) - 1, timeToWait), 0) // Checking max value for setTimeout
      );
    } catch (err) {
      console.error(err);
    }
  };
  this.logout = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(nextUri, logoutOfFederated) {
      var redirectUrl, url, sessionId;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // Auth0 logout code
              redirectUrl = nextUri ? window.location.origin + nextUri : window.location.origin;
              url = 'https://' + _this.domain + '/v2/logout';
              url += '?client_id=' + _this.clientID;
              url += '&returnTo=' + redirectUrl;
              if (logoutOfFederated) {
                url += '&federated';
              }
              sessionId = localStorage.getItem('sessionId');
              _context8.prev = 6;
              if (!sessionId) {
                _context8.next = 10;
                break;
              }
              _context8.next = 10;
              return fetch(SESSION_API_URL + '/' + sessionId + '/lifecycle/logout', {
                method: 'POST',
                headers: new Headers({
                  'x-session-id': sessionId
                })
              });
            case 10:
              _context8.next = 15;
              break;
            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8['catch'](6);
              console.error(_context8.t0);
            case 15:
              _context8.prev = 15;
              _this.clearLocalParams();
              window.location = url;
              return _context8.finish(15);
            case 19:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this, [[6, 12, 15, 19]]);
    }));
    return function (_x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }();
  this.clearLocalParams = function () {
    _this.clearSessionTimeout();
    _this.clearLocalStorage();
  };
  this.clearLocalStorage = function () {
    localStorage.removeItem('sessionId');
    localStorage.removeItem('sessionExpiresAt');
    localStorage.removeItem('profile');
    localStorage.removeItem('profileExpiresAt');
  };
  this.fetchUtil = function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return fetch(url, options);
            case 3:
              result = _context9.sent;
              if (!result.ok) {
                _context9.next = 6;
                break;
              }
              return _context9.abrupt('return', result.json());
            case 6:
              throw new Error(result);
            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9['catch'](0);
              console.error(JSON.stringify(_context9.t0));
              return _context9.abrupt('return', {});
            case 13:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this, [[0, 9]]);
    }));
    return function (_x10) {
      return _ref12.apply(this, arguments);
    };
  }();
};
exports.default = AuthorizationCodeGrantPKCE;